import { useRegisterTwaDeviceToken } from '#src/hooks/useTwaDeviceToken.ts';

// Must be mounted under CurrentUserProvider: the token is registered against
// the signed-in user.
export const RegisterTwaDeviceToken = () => {
  useRegisterTwaDeviceToken();
  return null;
};
